import { calculatePaginationOffset, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
export const cbomApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCryptography: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (e.g. auto-expand on single-match filters) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/cbom`,
                params: {
                    item_id: data.filter.item_id,
                    kind: data.filter.kind,
                    type: data.filter.type,
                    sort_by: convertSortToQueryString(data.sort),
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                },
            }),
        }),
        getCryptoAssetDetails: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/cbom/${data.ui_item_id}/components`,
                params: data,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetCryptographyQuery, useGetCryptoAssetDetailsQuery } = cbomApi;
//# sourceMappingURL=cbom.api.js.map